module.exports = __webpack_public_path__ + "img/spodoptera-frugiperda.b7fb9bdc.jpg";